import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect, useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import QuoteNavbar from '../../components/navigation/quoteNavbar';
import QuoteRoutes from './quoteRoutes';
import { css, StyleSheet } from 'aphrodite/no-important';
import { Alert } from '../../components';
import { primaryFont, textStyles, common } from '../../assets/theme';
import { globalStyles } from 'shared/styles';
import { Helmet } from 'react-helmet';
import i18n from '../../i18n';
import { withTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import { submissionResponse } from '../../screens/quote/quoteSelectors';
import CMSDataDispatcher from '../../containers/cms/cmsDataDispatcher';
import Lifecycle from 'page-lifecycle';
import { isMobile } from 'react-device-detect';
import { stripTrailingSlash, getEnvBasedNotifyEmail, updateLocalStorage } from '../../shared/utils';
import { notify } from 'actions/authActions';
const constant = require('../../../src/const');

const QuoteContainer = (props) => {
    const { location, submissionResponse } = props;
    const dispatch = useDispatch();
    const isAuthenticated = useSelector((state) => state.auth?.isAuthenticated);
    const [progressBarValue, setProgressBarValue] = useState(props.progressBarValue);

    useEffect(() => {
        setProgressBarValue(props.progressBarValue);
    }, [props.progressBarValue]);

    const validSession = window.sessionStorage.getItem('accessToken');
    useEffect(() => {
        Lifecycle.addEventListener('statechange', function (event) {
            const SESSIONDROP_DATA = JSON.parse(
                window.localStorage.getItem('SESSIONDROP_DATA')
                ? window.localStorage.getItem('SESSIONDROP_DATA')
                : null
            );
            const callBackConsent = window.sessionStorage.getItem('callBackConsent');
            if (event.newState === 'terminated' && callBackConsent === 'true') {
                beforeUnload(SESSIONDROP_DATA);
            }
            if (event.originalEvent.type !== 'blur' && event.newState === 'hidden' && callBackConsent === 'true') {
                beforeUnload(SESSIONDROP_DATA);
            }
        });
    }, []);

    const beforeUnload = (SESSIONDROP_DATA, toNotify) => {
        if (!SESSIONDROP_DATA?.isCustomerDropped && SESSIONDROP_DATA) {
            const apiRequest = {
                data: {
                    partyId: SESSIONDROP_DATA?.partyId,
                    submissionId: SESSIONDROP_DATA?.submissionId,
                    title:  SESSIONDROP_DATA?.renewal
                    ? 'ADNIC MOTOR - Renewal Lead'
                    : 'ADNIC MOTOR - New Lead',
                    toEmailId: getEnvBasedNotifyEmail(process.env),
                    url: constant.CSA_BASE_URL,
                    phoneNumber: SESSIONDROP_DATA?.phoneNumber,
                    emailAddress: SESSIONDROP_DATA?.emailAddress,
                    causeOfReferral: 'Customer dropped off',
                    vehicleDetails: SESSIONDROP_DATA?.vehicleDetails,
                    userName: SESSIONDROP_DATA?.userName ?? '',
                    nationality: SESSIONDROP_DATA?.nationality,
                    dateOfBirth: SESSIONDROP_DATA?.dateOfBirth,
                    offeringName: SESSIONDROP_DATA?.offeringName ?? '',
                    totalPremiumAmount: SESSIONDROP_DATA?.totalPremiumAmount,
                    insisQuoteNumber: SESSIONDROP_DATA?.insisQuoteNumber ?? '',
                    csaAssignTo: '',
                    remarks: '',
                },

                isToNotify: 'true',
                notificationBody: 'string',
                notificationChannel: 'EMAIL',
                notificationName: SESSIONDROP_DATA?.renewal
                    ? constant.RENEWAL_NOTIFICATION_TEMPLATE
                    : constant.NOTIFICATION_TEMPLATE,
                notificationPreferenceType: 'NA',
                notificationType: 'LEAD',
                partyId: SESSIONDROP_DATA.partyId,
            };

            let response = dispatch(notify(SESSIONDROP_DATA, apiRequest));
            if (response) {
                updateLocalStorage(SESSIONDROP_DATA, SESSIONDROP_DATA?.renewal, false, true);
            }
        }
    };

    useEffect(() => {
        //Zendesk Widget script
        if (typeof window.zE === 'function') {
            window.zE('webWidget', 'show');
        }
        // Remove the default static meta description in favor of react helmets dynamic one
        if (document.querySelector("[name='description']")) {
            document.querySelector("[name='description']").remove();
        }
    }, []);
    // useEffect(() => {
    //     window.gtag('event', 'page_view', {
    //         page_location: window.location.href,
    //         page_path: window.location.pathname,
    //         page_title: document.title,
    //     });
    // }, [window.location.href]);

    return (
        <>
            <Helmet>
                <title>{i18n.t('common.title')}</title>
                <meta name="description" content={i18n.t('common.metaDescription')} />
                <link rel="canonical" href="https://adnic.ae/app/quote" />
            </Helmet>
            <QuoteNavbar value={progressBarValue} />
            {/* <div style={{height: '80px', background: 'grey', width: '100%', position: 'fixed', top: '0'}}></div> */}
            <div
                className={
                    (css(globalStyles.contentContainer),
                    i18n.language === 'ar' ? css(styles.arabicLang) : css(styles.otherLang))
                }
            >
                {props.alertFlag && (
                    <Alert alertType="warning" hideAfterDuration durationToDisplay={2500}>
                        <p className={css(styles.text)}>
                            <span className={css(styles.highlighted)}>{props.alertMessage}</span>
                        </p>
                    </Alert>
                )}
                <div>
                    <CMSDataDispatcher>
                        <QuoteRoutes />
                    </CMSDataDispatcher>
                </div>
            </div>
        </>
    );
};

const styles = StyleSheet.create({
    arabicLang: {
        direction: 'rtl',
        textAlign: 'right',
    },
    otherLang: {
        direction: 'ltr',
        textAlign: 'left',
    },
    text: {
        margin: 0,
        ...textStyles.normal,
    },
    highlighted: {
        ...primaryFont.medium,
    },
    progressBar: {
        position: 'sticky',
        zIndex: 10,
    },
    //can be used when diff design is implemented
    // buttonContainer: {
    //     display: 'flex',
    //     minWidth: 300,
    //     paddingTop: 40,
    // },
    // linkContainer: {
    //     marginLeft: 8,
    //     marginRight: 8,
    // },
});

QuoteContainer.propTypes = {
    // progressStep: PropTypes.number.isRequired,
    alertFlag: PropTypes.bool.isRequired,
    alertMessage: PropTypes.string.isRequired,
    location: PropTypes.shape({ pathname: PropTypes.string }).isRequired,
};

const mapStateToProps = (state) => ({
    //   progressStep: state.progress.step,
    alertFlag: state.alertComponent.alertFlag,
    alertMessage: state.alertComponent.message,
    progressBarValue: state.quote.progressBarValue,
    submissionResponse: submissionResponse(state),
});

export default withTranslation()(withRouter(connect(mapStateToProps)(QuoteContainer)));
